import React, { useState, useEffect } from 'react';
import compose from 'lodash/fp/compose';
import { useMutation } from '@apollo/client';
import { withCustomer } from '@catalogo/core-connect/customer';
import { withRouter } from 'react-router';
import { withMetrics } from '@catalogo/core-metrics';
import { feedbackReview } from '../../queries/productReviews.graphql';

export const withReviewFeedback = Component => props => {
  const { negativeFeedback, positiveFeedback, customer, history, productId, dispatchMetrics } = props;
  const [feedbackType, setFeedbackType] = useState(undefined);
  const [like, setLike] = useState(false);
  const [dislike, setDislike] = useState(false);
  const [likeCount, setLikeCount] = useState(0);
  const [dislikeCount, setDislikeCount] = useState(0);
  const [feedbackAction] = useMutation(feedbackReview);

  useEffect(() => {
    setLikeCount(positiveFeedback);
    setDislikeCount(negativeFeedback);
  }, []);

  const handleLike = () => {
    setLikeCount(like ? likeCount - 1 : likeCount + 1);
    setLike(!like);
    return dislike ? handleDislike() : false;
  };

  const handleDislike = () => {
    setDislikeCount(dislike ? dislikeCount - 1 : dislikeCount + 1);
    setDislike(!dislike);
    return like ? handleLike() : false;
  };

  const sendFeedbackMutation = async () => {
    const variables = {
      productId,
      contentId: feedbackType.id,
      vote: feedbackType.Vote,
    };
    const result = await feedbackAction({
      variables,
    });
    if (result?.data?.feedbackReview?.status === 200) {
      feedbackType.Vote === 'Positive' ? handleLike() : handleDislike();
    }
    return setFeedbackType(undefined);
  };

  const handleClick = params => {
    const vote = params.Vote === 'Positive' ? 'like' : 'dislike';
    dispatchMetrics('event:track', {
      category: 'product',
      action: `Avaliações - Feedback`,
      label: vote,
    });
    if (!customer?.id) {
      return history.push('#modal-login');
    }
    !feedbackType && setFeedbackType({ Vote: params.Vote, id: params.id });
  };

  useEffect(() => {
    if (feedbackType) {
      sendFeedbackMutation();
    }
  }, [feedbackType]);

  const feedbackProps = { like, dislike, likeCount, dislikeCount };

  return <Component {...props} handleClick={handleClick} feedback={feedbackProps} />;
};

export default compose(withRouter, withCustomer, withMetrics, withReviewFeedback);
